import {ProcessadorTexto} from "./ProcessadorTexto";
import {environment} from "../../../environments/environment";
declare const global: any;

export class ProcessadorNfceTexto extends ProcessadorTexto {
  textoPequeno = false
  obtenhaTextoNfce(nfce: any): string {
    if (this.impressora.modoHTML) {
      if (environment.production === false) { // Ambiente de desenvolvimento
        return `http://localhost:3100/nfce/${nfce.id}/danfe`;
      } else {
        return `/nfce/${nfce.id}/danfe`;
      }
    }


    let texto = ""



    texto += this.ativarLetraPequena()
    texto += this.cabecalho(nfce)
    texto += this.detalhes(nfce)
    texto += this.totais(nfce)
    texto += this.consultaChave(nfce)
    texto += this.consumidor(nfce)
    texto += this.identificacaoNfce(nfce)
    texto += this.qrcode(nfce)
    texto += this.mensagem(nfce)
    texto += this.ativarLetraNormal()

    return texto;

  }
  private formateEndereco(endereco) {
    let enderecoFormatado = []
    enderecoFormatado.push(
      endereco.logradouro +
      (endereco.numero ? ", " + endereco.numero : "") +
      (endereco.complemento ? ", " + endereco.complemento : "")
    )
    enderecoFormatado.push(endereco.bairro + " - " + endereco.nomeMunicipio + "/" + endereco.siglaUF)
    if(endereco.telefone) enderecoFormatado.push("Telefone: " + endereco.telefone)

    return enderecoFormatado;
  }

  private linhaHorizontal() {

    let texto = this.linhaComCaracter("-")

    return texto
  }

  /*
  private linhaHorizontalPequena() {
    return this.linhaComCaracterPequeno("-")
  }
  */


  private cabecalho(nfce: any) {
    let texto = this.ativarNegrito()
    texto += this.centralizarLinha('CNPJ: ' + nfce.emitente.cnpj + ' ' + nfce.emitente.razaoSocial)
    let linhasEndereco = this.formateEndereco(nfce.emitente.endereco)

    for(let i = 0; i < linhasEndereco.length; i++) {
      texto += this.centralizarLinha(linhasEndereco[i])
    }
    texto += this.desativarNegrito()
    texto += this.linhaHorizontal()
    texto += this.centralizarMultiplasLinhas("Documento Auxiliar da Nota Fiscal de Consumidor Eletrônica", this.papel.tamanhoLinha)
    //texto += this.ativarLetraPequena()
    texto += this.centralizarMultiplasLinhas("Não permite aproveitamento de crédito de ICMS", this.papel.tamanhoLinha)
    //texto += this.ativarLetraNormal()


    return texto;
  }

  private centralizarMultiplasLinhas(texto: string, tamanhoLinha: number) {
    let linhas = this.multiplasLinhas(texto, this.papel.tamanhoLinha, false)

    let retorno = ""
    for(let i = 0; i < linhas.length; i++)
      retorno += this.centralizarLinha(linhas[i])


    return retorno
  }

  private detalhes(nfce: any) {
    let texto = ""

    texto += this.linhaHorizontal()

    const tamanhoCodigo = 6
    const espacoEntreColunas = 2
    const tamanhoQtde = 5
    const tamanhoUn = 3
    const tamanhoVlUnit = 10
    const tamanhoVlTotal = 10

    const tamanhoDescricao =
      this.papel.tamanhoLinha
      - tamanhoCodigo
      - espacoEntreColunas
      - tamanhoQtde
      - tamanhoUn
      - tamanhoVlUnit
      - tamanhoVlTotal

    texto += this.linha(
      this.alinhadoEsquerda("Código", tamanhoCodigo) +
      this.espaco(espacoEntreColunas) +
      this.alinhadoEsquerda("Descrição", tamanhoDescricao) +
      this.alinhadoEsquerda("Qtde", tamanhoQtde) +
      this.alinhadoEsquerda("UN", tamanhoUn) +
      this.alinhadoEsquerda("Vl Unit", tamanhoVlUnit) +
      this.alinhadoEsquerda("Vl Total", tamanhoVlTotal)
    )

    texto += this.linhaHorizontal()

    if (nfce.itens) {
      nfce.itens.forEach((item, index) => {
        const codigo = String(item.codigo || '')

        const descricaoPadrao = String(item.descricao || '')
        const descricao =
          (nfce.ambiente === 2 && index === 0)
            ? "NOTA FISCAL EMITIDA EM AMBIENTE DE HOMOLOGACAO - SEM VALOR FISCAL"
            : descricaoPadrao

        const qtd = String(item.qtd || '')
        const un = String(item.un || '')
        const vlUnit = this.formatarValor(item.valorUnitario)
        const vlTotal = this.formatarValor(item.valorTotal)

        // Quebra a descrição em múltiplas linhas respeitando o tamanho da coluna,
        // sem quebrar palavras (fica mais legível em cupom).
        const linhasDescricao = this.multiplasLinhas(descricao, tamanhoDescricao, false)
        const primeiraLinhaDescricao = (linhasDescricao.length > 0 ? linhasDescricao[0] : "")

        // Linha principal do item (com todas as colunas)
        texto += this.linha(
          this.alinhadoEsquerda(codigo, tamanhoCodigo) +
          this.espaco(espacoEntreColunas) +
          this.alinhadoEsquerda(primeiraLinhaDescricao, tamanhoDescricao) +
          this.alinhadoEsquerda(qtd, tamanhoQtde) +
          this.alinhadoEsquerda(un, tamanhoUn) +
          this.alinhadoEsquerda(vlUnit, tamanhoVlUnit) +
          this.alinhadoEsquerda(vlTotal, tamanhoVlTotal)
        )

        // Linhas adicionais: só continuação da descrição (demais colunas vazias)
        for (let i = 1; i < linhasDescricao.length; i++) {
          texto += this.linha(
            this.alinhadoEsquerda("", tamanhoCodigo) +
            this.espaco(espacoEntreColunas) +
            this.alinhadoEsquerda(linhasDescricao[i], tamanhoDescricao) +
            this.alinhadoEsquerda("", tamanhoQtde) +
            this.alinhadoEsquerda("", tamanhoUn) +
            this.alinhadoEsquerda("", tamanhoVlUnit) +
            this.alinhadoEsquerda("", tamanhoVlTotal)
          )
        }
      })
    }

    texto += this.linhaHorizontal()
    return texto
  }
  private ativarLetraNormal() {
    if(this.textoPequeno) {
      this.papel.tamanhoLinha -= 14
      this.textoPequeno = false ;
    }

    return '\x1B' + '\x4D' + '\x00';
  }

  private ativarLetraPequena() {
    if(!this.textoPequeno) {
      this.papel.tamanhoLinha += 14
      this.textoPequeno = true;
    }

   return '\x1B' + '\x4D' + '\x01';
  }

  private formatarValor(valor: number): string {
    if (valor === null || valor === undefined) return '';
    return valor.toFixed(2);
  }

  private totais(nfce: any) {
    let texto = ""
    const qtdeItens = String(nfce.itens ? nfce.itens.length : 0);
    const valorItens = this.formatarValor(nfce.valorItens);
    const valorTotal = this.formatarValor(nfce.valorTotal);

    texto += this.linha(this.alinhadoEsquerda("Qtde. total de itens: " + qtdeItens, this.papel.tamanhoLinha))
    texto += this.linha(this.alinhadoEsquerda("Valor itens R$ " + valorItens, this.papel.tamanhoLinha))
    texto += this.ativarNegrito()
    texto += this.linha(this.alinhadoEsquerda("Valor total R$ " + valorTotal, this.papel.tamanhoLinha))
    texto += this.desativarNegrito()
    //texto += this.ativarLetraPequena()
    texto += this.linhaHorizontal()

    let tamanhoFormaPagamento = 20
    let tamanhoValorPago = this.papel.tamanhoLinha - 25

    texto += this.linha(this.alinhadoEsquerda("FORMA DE PAGAMENTO", tamanhoFormaPagamento) + "    " +
      this.alinhadoDireita("VALOR PAGO R$", tamanhoValorPago))

    if (nfce.pagamentos) {
      nfce.pagamentos.forEach(pagamento => {
        const forma = String(pagamento.forma || '');
        const valor = this.formatarValor(pagamento.valor);

        texto += this.linha(this.alinhadoEsquerda(forma, tamanhoFormaPagamento) + "    " +
          this.alinhadoDireita(valor, tamanhoValorPago))
      })
    }

    texto += this.linhaHorizontal()
    //texto += this.ativarLetraNormal()
    return texto;
  }

  private ativarNegrito() {
    return '\x1B\x45\x01'
  }

  private desativarNegrito() {
    return '\x1B\x45\x00'
  }

  private consultaChave(nfce: any) {

    let texto = "" // this.ativarLetraPequena()
    texto += this.ativarNegrito()
    texto += this.centralizarLinha("Consulte pela chave de acesso em")
    texto += this.desativarNegrito()
    texto += this.centralizarLinha(nfce.urlConsulta)
    texto += this.ativarNegrito()
    texto += this.centralizarLinha(nfce.chaveAcesso)
    texto += this.desativarNegrito()
    texto += this.linha()
    //texto += this.ativarLetraNormal()
    return texto;
  }

  private identificacaoNfce(nfce: any) {
    let texto =  "" //this.ativarLetraPequena()
    texto += this.ativarNegrito()
    texto += this.centralizarLinha(`NFC-e n ${String(nfce.numeroNFe).padStart(9, '0')} Série ${nfce.serie} ${this.formataDataHora(nfce.dataEmissao)}`)
    texto += this.centralizarLinha("Protocolo de autorização: " + nfce.protocolo)
    texto += this.centralizarLinha("Data de autorização: " + (nfce.dataAutorizacao || ''))
    texto += this.desativarNegrito()
    //texto += this.ativarLetraNormal()
    return texto;
  }

  private formataDataHora(data: Date): string {
    if (!data) return '';
    return new Date(data).toLocaleString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  }

  private consumidor(nfce: any) {
    let texto = ""
    texto += this.centralizarLinha("Consumidor")

    let linhaConsumidor = ""

    if (nfce.ambiente === 2) {
      linhaConsumidor = "NF-E EMITIDA EM AMBIENTE DE HOMOLOGACAO - SEM VALOR FISCAL"
    } else if (!nfce.destinatario) {
      linhaConsumidor = "CONSUMIDOR NÃO IDENTIFICADO"
    } else {
      linhaConsumidor = `${nfce.destinatario.nome} - CPF - ${nfce.destinatario.cpf}`
    }

    // quebra em múltiplas linhas no tamanho do papel e centraliza cada linha
    const linhas = this.multiplasLinhas(String(linhaConsumidor || ''), this.papel.tamanhoLinha, false)
    for (let i = 0; i < linhas.length; i++) {
      texto += this.centralizarLinha(linhas[i].trim())
    }

    texto += this.linha()
    return texto
  }



  private qrcode(nfce: any = "") {

    console.log(nfce)
    let texto = nfce.qrCode || ""
    let dots = '\x06';
    let qrLength = texto.length + 3;

    console.log('Texto qrcode: ' + texto)

    let size1 = String.fromCharCode(qrLength % 256);
    let size0 = String.fromCharCode(Math.floor(qrLength / 256));
    let data = [ '\x1B' + '\x61' + '\x31',
      '\x1D' + '\x28' + '\x6B' + '\x04' + '\x00' + '\x31' + '\x41' + '\x32' + '\x00',
      '\x1D' + '\x28' + '\x6B' + '\x03' + '\x00' + '\x31' + '\x43' + dots,
      '\x1D' + '\x28' + '\x6B' + '\x03' + '\x00' + '\x31' + '\x45' + '\x30',
      '\x1D' + '\x28' + '\x6B' + size1 + size0 + '\x31' + '\x50' + '\x30' + texto,
      '\x1D' + '\x28' + '\x6B' + '\x03' + '\x00' + '\x31' + '\x51' + '\x30',
      '\x1D' + '\x28' + '\x6B' + '\x03' + '\x00' + '\x31' + '\x52' + '\x30',
    ];

    return data.join('') + this.papel.quebraLinha;
  }

  private mensagem(nfce: any) {
    return nfce.mensagem;
  }
}
